import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsReduce = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g fill="currentColor">
        <path
          d="M18.8104172,0.2951118l-0.0000019-0.0000014H5.1895862c-2.6909666,0-4.8816152,2.1906486-4.8816152,4.883954
			v6.4269919c0,0.4231682,0.3202979,0.741127,0.7458014,0.741127c0.4255052,0,0.745803-0.3202982,0.745803-0.7458029V5.1767259
			c0-1.8563225,1.5103092-3.368969,3.3689704-3.368969h13.6418695c1.8563232,0,3.368969,1.5103077,3.368969,3.368969v13.6675892
			c0,1.8563232-1.5103073,3.368969-3.368969,3.368969h-6.354517c-0.4255047,0-0.745801,0.3202972-0.745801,0.7458038
			c0,0.4184914,0.3273115,0.7458019,0.745801,0.7458019h6.3521805c0.0163651,0,0.0327301,0,0.0490952,0
			c1.2718391,0,2.4735394-0.4979801,3.3876743-1.4027634c0.9328365-0.9234848,1.4471836-2.1509037,1.4471836-3.4554729V5.1790657
			C23.6920319,2.4857605,21.5013828,0.2951118,18.8104172,0.2951118z"
        />
        <path
          d="M7.3825707,22.1828899H2.8609986l10.0391064-10.0391064
			c0.1426134-0.1426134,0.2244415-0.3319874,0.2244415-0.519022c0-0.1870356-0.0818281-0.3740702-0.2244415-0.5190229
			c-0.1356001-0.1356001-0.3436775-0.2244434-0.5190229-0.2244434s-0.3834209,0.0911808-0.5166836,0.2244434L1.7995739,21.1261425
			V16.602232c0-0.4255066-0.3202978-0.7458038-0.7458029-0.7458038s-0.745803,0.3202972-0.745803,0.7458038v6.3287983
			c0,0.4255066,0.3202978,0.7458038,0.745803,0.7458038h6.3287997c0.4255052,0,0.7458034-0.3202972,0.7458034-0.7458038
			C8.1260347,22.5102024,7.7987237,22.1828899,7.3825707,22.1828899z"
        />
      </g>
    </SvgIcon>
  );
});

export default AppIconsReduce;
